import React, { Component } from 'react'
import { Button, Card, Col, List, Row, notification } from 'antd';
import Request from '../../request'
import moment from 'moment'
import ListDrawer from './list';
import ReceiptsView from '../../components/DocumentViews/receiptsView'
import { RightsWrapper } from '../../components/_utils/utils';
import FinanceClaim from '../finance/all/index';
import AllInvoiceFollowUp from '../../components/_utils/allInvoiceFollowUp';

import {
    FaMoneyCheckAlt,
    FaRegBuilding,
    FaUserCog,
    FaFileInvoiceDollar,
    FaRegMoneyBillAlt,
    FaFileInvoice,
    FaPlaneDeparture,
    FaHistory,
    FaUserSlash,
    FaUserTimes,
    FaUserCheck,
    FaUserClock
} from "react-icons/fa";

import ConsultancyIcon from '../../assets/icons/registration/ConsultancyIcon.png'
import RegistrationIcon from '../../assets/icons/registration/RegistrationIcon.png'
import OutstandingIcon from '../../assets/icons/registration/OutstandingIcon.png'
import { getUrlPushWrapper } from "../../routes";
import { connect } from "react-redux";
import {
    FaRupeeSign
} from "react-icons/fa";
import FinanceTaxesCount from '../../components/Dashboard/financeTaxesCount';
import ConsultancyReceivedCounts from './consultancyReceivedCounts';

class FinanceCommissionDashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            coldCount: 0,
            outstandingAgreement: {
                total: 0,
                arr: []
            },
            drawer: false,
            drawerParam: {},
            todaySubmittedReceipts: [],
            showTPSCSubmittedButton: false,
            showTECSubmittedButton: false,
            showAccountPaymentDrawar: false,
            submitReceiptCount: {
                submittedCount: 0,
                approvedCount: 0
            },
            visaApprovedTodayCount: {
                total: 0
            },
            invoiceToBeGeneratedTodayCount: {
                total: 0
            },
            invoiceGeneratedTodayCount: {
                total: 0
            },
            totalTaxCount: {
                total: 0
            },
            totalCompaniesDetailsCount: {
                total: 0
            },
            totalInvoicesToDetailsCount: {
                total: 0
            },
            universityCommissionEntered: {
                total: 0
            },
            courseCommissionEntered: {
                total: 0
            },
            InvoiceWaitingForCommissionEntered: {
                total: 0
            },
            overdueInvoices: {
                total: 0
            },
            totalWithdrawStudents: {
                total: 0
            },
            totalWithdrawRequestSent: {
                total: 0
            },
            studentWithdrawRequestApproved: {
                total: 0
            },
            studentWithdrawRequestRejected: {
                total: 0
            },
            paymentTypeFilter: 'ALL'
        }
    }

    loadApi = async () => {
        Request.monthWeakCount({ atLevel: ['Registration Desk'] }).then(({ data: monthAndWeak }) => {
            this.setState({ monthAndWeak })
        })
        Request.consultancyReceivedData({ atLevel: ['Registration Desk'] }).then(({ data: registrationConsultancyData, outstandingAgreement }) => {
            this.setState({
                consultancyReceivedData: registrationConsultancyData && registrationConsultancyData.consultancyData,
                outstandingConsultancy: registrationConsultancyData && registrationConsultancyData.outstandingConsultancy,
                totalOutstandingConsultancyCount: registrationConsultancyData && registrationConsultancyData.totalOutstandingConsultancyCount
            })
        })
        Request.getTodaySubmittedReceipts().then((response) => {
            this.setState({
                todaySubmittedReceipts: response.data.receipts,
                submitReceiptCount: {
                    submittedCount: response.data.todaySubmittedCount,
                    approvedCount: response.data.todayApprovedCount
                }
            })
        });
        Request.getCliamDeskData().then(({
            visaApprovedTodayCount,
            invoiceToBeGeneratedTodayCount,
            invoiceGeneratedTodayCount,
            overdueInvoices,
            totalWithdrawStudents,
            totalWithdrawRequestSent,
            studentWithdrawRequestApproved,
            studentWithdrawRequestRejected,
            totalTaxCount,
            totalCompaniesDetailsCount,
            totalInvoicesToDetailsCount,
            universityCommissionEntered,
            courseCommissionEntered
        }) => {
            this.setState({
                visaApprovedTodayCount,
                invoiceToBeGeneratedTodayCount,
                invoiceGeneratedTodayCount,
                overdueInvoices,
                totalWithdrawStudents,
                totalWithdrawRequestSent,
                studentWithdrawRequestApproved,
                studentWithdrawRequestRejected,
                totalTaxCount,
                totalCompaniesDetailsCount,
                totalInvoicesToDetailsCount,
                universityCommissionEntered,
                courseCommissionEntered
            });
        });
    }

    async componentDidMount() {
        await this.loadApi();
    }

    approveTodayFees = async () => {
        let response = await Request.approveTodayFees({});
        if (response.success === true) {
            notification.success({
                message: response.msg,
            });
            this.loadApi();
        } else {
            notification.error({ message: "Try again" });
        }
    }

    viewAccountPaymentReceipt = () => {
        this.setState({
            showAccountPaymentDrawar: true
        })
    }

    closeDocument = () => {
        this.setState({ showAccountPaymentDrawar: false });
    }

    exportExcelTodaysReceipts = async () => {
        let response = await Request.exportTodaysPayments();
        if (!response.error) {
            window.location.href = response.url;
        }
    }

    render() {
        let { dispatch } = this.props

        const {
            visaApprovedTodayCount,
            invoiceToBeGeneratedTodayCount,
            invoiceGeneratedTodayCount,
            totalTaxCount,
            totalCompaniesDetailsCount,
            totalInvoicesToDetailsCount,
            universityCommissionEntered,
            courseCommissionEntered,
            overdueInvoices,
            totalWithdrawStudents,
            totalWithdrawRequestSent,
            studentWithdrawRequestApproved,
            studentWithdrawRequestRejected,
            showAccountPaymentDrawar
        } = this.state;

        const {
            monthAndWeak,
            consultancyReceivedData,
            outstandingConsultancy,
            totalOutstandingConsultancyCount,
            todaySubmittedReceipts,
            submitReceiptCount,
            drawer,
            drawerParam
        } = this.state;

        let todaysPaymentHtml = [];
        let totalPaidToday = 0;
        const filteredReceipts = this.state.paymentTypeFilter === "ALL"
            ? todaySubmittedReceipts
            : todaySubmittedReceipts.filter(
                r => r.paymentType === this.state.paymentTypeFilter
            );
        filteredReceipts.map((todayRegistrationsReceipt, index) => {
            totalPaidToday += parseFloat(todayRegistrationsReceipt.totalAmount);
            todaysPaymentHtml.push(
                <tr key={index}>
                    <td>{todayRegistrationsReceipt.amountType}</td>
                    <td>{todayRegistrationsReceipt.studentId}</td>
                    <td>{todayRegistrationsReceipt.studentName}</td>
                    <td>{todayRegistrationsReceipt.dob}</td>
                    <td>{todayRegistrationsReceipt.receiptNumber}</td>
                    <td><FaRupeeSign />{todayRegistrationsReceipt.totalAmount}</td>
                    <td>{todayRegistrationsReceipt.paymentType}</td>
                    <td>{todayRegistrationsReceipt.remarks}</td>
                    <td>{todayRegistrationsReceipt.submittedDate && todayRegistrationsReceipt.approvedDate ? 'Approved' : (todayRegistrationsReceipt.submittedDate ? 'Submitted' : 'Pending')}</td>
                </tr>
            )
        })
        let showApprovedButton = false;
        if (this.state.todaySubmittedReceipts && this.state.todaySubmittedReceipts.length === this.state.submitReceiptCount.submittedCount) {
            showApprovedButton = true;
        }
        if (this.state.todaySubmittedReceipts && this.state.todaySubmittedReceipts.length === this.state.submitReceiptCount.approvedCount) {
            showApprovedButton = false;
        }

        return (
            <div>
                <div className="site-card-wrapper">
                    {
                        showAccountPaymentDrawar ?
                            <ReceiptsView onClose={this.closeDocument} />
                            : null
                    }
                    <RightsWrapper myRight={"todayRegistrationFees.view"}>

                        <Row>
                            {
                                todaySubmittedReceipts && todaySubmittedReceipts.length > 0 ?
                                    <Col span={24} style={{ marginTop: '20px' }}>
                                        <h3>{`Today's Registration Fees : ${filteredReceipts.length}`}</h3>
                                        <table cellPadding={10} className='student-custom-table'>
                                            <thead>
                                                <tr>
                                                    <th>Amount Type</th>
                                                    <th>Student ID</th>
                                                    <th>Student Name</th>
                                                    <th>DOB</th>
                                                    <th>Receipt Number</th>
                                                    <th>Received Amount</th>
                                                    <th>
                                                        Payment Type
                                                        <select
                                                            value={this.state.paymentTypeFilter}
                                                            onChange={(e) => this.setState({ paymentTypeFilter: e.target.value })}
                                                            style={{
                                                                marginLeft: "5px",
                                                                backgroundColor: "#ffffff",  // white background
                                                                color: "#000000",            // black text
                                                                border: "1px solid #ccc",
                                                                borderRadius: "4px",
                                                                padding: "2px 6px"
                                                            }}
                                                        >
                                                            <option value="ALL">All</option>
                                                            {Array.from(new Set(todaySubmittedReceipts.map(r => r.paymentType))).map((type, i) => (
                                                                <option key={i} value={type}>{type}</option>
                                                            ))}
                                                        </select>
                                                    </th>


                                                    <th>Remarks</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {
                                                    todaysPaymentHtml
                                                }
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th><FaRupeeSign />{totalPaidToday}</th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                                {
                                                    showApprovedButton ?
                                                        <tr>
                                                            <td>Approve Receipts Submitted by Account Department</td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <Button
                                                                    type='button'
                                                                    onClick={() => {
                                                                        this.approveTodayFees();
                                                                    }}
                                                                >
                                                                    Approve
                                                                </Button>
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td>{submitReceiptCount.submittedCount > 0 && submitReceiptCount.approvedCount > 0 ? 'Request Approved' : 'Submitted Request Received'}</td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                {
                                                                    submitReceiptCount.submittedCount > 0 ?
                                                                        <Button
                                                                            onClick={() => {
                                                                                this.viewAccountPaymentReceipt()
                                                                            }}
                                                                            type='button'
                                                                        >
                                                                            Print Receipts
                                                                        </Button>
                                                                        : null
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    submitReceiptCount.submittedCount > 0 ?
                                                                        <Button
                                                                            onClick={() => {
                                                                                this.exportExcelTodaysReceipts()
                                                                            }}
                                                                            type='button'
                                                                        >
                                                                            Export Excel
                                                                        </Button>
                                                                        : null
                                                                }
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                }
                                            </tfoot>
                                        </table>
                                    </Col>
                                    : null
                            }
                        </Row>
                    </RightsWrapper>
                    {/* <Row>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-1 elevation-1"><FaMoneyCheckAlt /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Total Tax Count</span>
                                    <span className="info-box-number">
                                        <a href='/finance-tax' target='_blank'>{totalTaxCount.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-2 elevation-1"><FaRegBuilding /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Total Companies Details Counts</span>
                                    <span className="info-box-number">
                                        <a href='/company-details' target='_blank'>{totalCompaniesDetailsCount.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-3 elevation-1"><FaUserCog /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Total Invoice To Details Count</span>
                                    <span className="info-box-number">
                                        <a href='/invoice-to-details' target='_blank'>{totalInvoicesToDetailsCount.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-4 elevation-1"><FaPlaneDeparture /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Visa Approved Today</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Visa Approved Today`,
                                                    arr: visaApprovedTodayCount.arr,
                                                    count: visaApprovedTodayCount.total
                                                }
                                            })
                                        }}>{visaApprovedTodayCount.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-5 elevation-1"><FaFileInvoice /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Invoice To Be Generated Today</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Invoice To Be Generated Today`,
                                                    arr: invoiceToBeGeneratedTodayCount.arr,
                                                    count: invoiceToBeGeneratedTodayCount.total
                                                }
                                            })
                                        }}>{invoiceToBeGeneratedTodayCount.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-6 elevation-1"><FaFileInvoiceDollar /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Invoice Generated Today</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Invoice Generated Today`,
                                                    arr: invoiceGeneratedTodayCount.arr,
                                                    count: invoiceGeneratedTodayCount.total
                                                }
                                            })
                                        }}>{invoiceGeneratedTodayCount.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-7 elevation-1"><FaRegMoneyBillAlt /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">University Commission Entered</span>
                                    <span className="info-box-number">
                                        <a href='/finance-university-commission' target='_blank'>{universityCommissionEntered.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-1 elevation-1"><FaFileInvoice /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Course Commission Entered</span>
                                    <span className="info-box-number">
                                        <a href='/finance-course-commission' target='_blank'>{courseCommissionEntered.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-2 elevation-1"><FaHistory /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Overdue Invoices</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Overdue Invoices`,
                                                    arr: overdueInvoices.arr,
                                                    count: overdueInvoices.total
                                                }
                                            })
                                        }}>{overdueInvoices.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-3 elevation-1"><FaUserSlash /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Total Withdraw Students</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Total Withdraw Students`,
                                                    arr: totalWithdrawStudents.arr,
                                                    count: totalWithdrawStudents.total
                                                }
                                            })
                                        }}>{totalWithdrawStudents.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-4 elevation-1"><FaUserClock /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Student Withdraw Request Sent</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Student Withdraw Request Sent`,
                                                    arr: totalWithdrawRequestSent.arr,
                                                    count: totalWithdrawRequestSent.total
                                                }
                                            })
                                        }}>{totalWithdrawRequestSent.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-5 elevation-1"><FaUserCheck /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Student Withdraw Request Approved</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Student Withdraw Request Approved`,
                                                    arr: studentWithdrawRequestApproved.arr,
                                                    count: studentWithdrawRequestApproved.total
                                                }
                                            })
                                        }}>{studentWithdrawRequestApproved.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col span={8} style={{padding: '10px'}}>
                            <div className="info-box">
                                <span className="info-box-icon bg-color-6 elevation-1"><FaUserTimes /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Student Withdraw Request Rejected</span>
                                    <span className="info-box-number">
                                        <button onClick={() => {
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: `Student Withdraw Request Rejected`,
                                                    arr: studentWithdrawRequestRejected.arr,
                                                    count: studentWithdrawRequestRejected.total
                                                }
                                            })
                                        }}>{studentWithdrawRequestRejected.total}</button>
                                    </span>
                                </div>
                            </div>
                        </Col>
                    </Row> */}

                    {/* <Row gutter={16}>
                        {
                            drawer && <ListDrawer
                            param={drawerParam}
                            onClose={() => {
                                this.setState({drawer: false})
                            }}/>
                        }
                        <Col span={8}>
                            <Card style={{height: '182px'}}

                                  headStyle={{
                                      backgroundColor: '#2b208d',
                                      color: 'white',
                                      minHeight: '11px',
                                      fontSize: '15px'
                                  }}
                                  bodyStyle={{padding: '4px'}}
                                  title={
                                    <span>
                                        <img src={ConsultancyIcon} alt="card"/> Consultancy Received
                                    </span>
                                  }>
                                <List
                                    size="small"
                                    bordered={false}
                                    dataSource={consultancyReceivedData ? consultancyReceivedData : []}
                                    renderItem={val => (<List.Item>

                                        <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                                            {val.date === moment().format('DD-MM-YYYY') ?
                                                <div style={{color: '#2b208d'}}>Today</div> :
                                                <div>{val.date}</div>}
                                            {val.date === moment().format('DD-MM-YYYY') ?
                                                <div style={{paddingLeft: '30px', color: '#2b208d'}}>-</div> :
                                                <div>-</div>}

                                            {val && val.count !== 0 ? <button onClick={() => {
                                                dispatch(
                                                    getUrlPushWrapper('desk.registration', {registrationDate: val && val.date})
                                                )
                                            }}>

                                                <div style={{color: '#2b208d'}}> {val.count}</div>
                                            </button> : <div>{val.count}</div>}

                                        </div>
                                    </List.Item>)
                                    }
                                >
                                </List>
                            </Card>
                        </Col>
                        <Col span={8}>
                            <Row>
                                <Col>
                                    <div style={{marginTop: '10px'}}>
                                        <div style={{
                                            padding: '10px',
                                            color: 'white',
                                            backgroundColor: '#e85c43',
                                            fontSize: '15px',
                                            fontWeight: '500'
                                        }}>Outstanding Consultancy
                                        </div>
                                        <div style={{
                                            padding: '14px',
                                            color: 'white',
                                            fontSize: '10px',
                                            backgroundColor: '#d94d33'
                                        }}>
                                            <span style={{fontSize: '15px'}}>Total</span> (INR)<span
                                            style={{
                                                fontSize: '15px',
                                                marginLeft: '5px'
                                            }}>{outstandingConsultancy ? outstandingConsultancy : 0}</span>
                                            <span
                                                style={{
                                                    fontSize: '15px',
                                                    marginLeft: '30px'
                                                }}>Count : ({totalOutstandingConsultancyCount ? totalOutstandingConsultancyCount : 0})</span>
                                            <img src={OutstandingIcon} alt="card"
                                                 style={{float: 'right', height: '22px', width: '22px'}}/>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={8}>
                            <Row>
                                <Col> 
                                    <Card title={<span><img src={RegistrationIcon} alt="card"/> Registrations</span>}
                                        bordered={false} 
                                            headStyle={{
                                            backgroundColor: '#85cf4a',
                                            color: 'white',
                                            minHeight: '11px',
                                            fontSize: '15px'
                                        }}
                                        bodyStyle={{padding: '8px', height: '46px'}}>
                                        <Row>
                                            <Col span={12} style={{textAlign: 'center', borderRight: '1px solid #ededed'}}>
                                                <div>Weekly</div>

                                                <div><button onClick={() => {
                                                    dispatch(
                                                        getUrlPushWrapper('desk.registration', {dateFilterByWeekOrMonth: 'week'})
                                                    )

                                                }}>{monthAndWeak ? monthAndWeak.weakCount : 0} </button></div>
                                            </Col>
                                            <Col style={{textAlign: 'center'}}
                                                span={12}>
                                                <div>Monthly</div>

                                                <div><button onClick={() => {
                                                    dispatch(
                                                        getUrlPushWrapper('desk.registration', {dateFilterByWeekOrMonth: 'month'})
                                                    )

                                                }}> {monthAndWeak ? monthAndWeak.monthCount : 0}</button></div>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row> */}

                    <FinanceTaxesCount />
                    <ConsultancyReceivedCounts />
                    <RightsWrapper myRight={"allInvoiceFollowUp.view"}>
                        <Row style={{ marginTop: '30px' }}>
                            <AllInvoiceFollowUp />
                        </Row>
                    </RightsWrapper>
                    <Row style={{ marginTop: '30px' }}>
                        <RightsWrapper myRight={"financePendingInvoices.view"}>
                            <FinanceClaim showInvoice="today" showPageWrapper="false" />
                        </RightsWrapper>
                    </Row>
                </div>

            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapDispatchToProps)
    (FinanceCommissionDashboard)
